<template>
    <div>
        <dead-end-layout>
            <div class="closed-content">
                <h1 class="display-3 bold closed-title">Sorry, we are currently closed.</h1>
                <p>Thank you for choosing {{ storeName }}. Our online ordering is currently unavailable. We apologise for any inconvenience and look forward to serving you soon.</p>
                <p><b>Online opening hours</b></p>
                <ul class="opening-hours" v-if="openingHours">
                    <li v-for="schedule in openingHours">
                        {{ schedule }}
                    </li>
                </ul>
            </div>
        </dead-end-layout>
    </div>
</template>
<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component'
import { Icon } from '@/front/icons';
import Settings, { SettingNamespace } from '@/utils/settings';
import DeadEndLayout from '@/components/front/ui/DeadEndLayout.vue';
import { convertTo12HourFormat } from '@/utils/utilities';

@Component({ components: { DeadEndLayout } })
export default class ClosedPage extends Vue
{
    storeClosed: boolean = false;
    storeName: string = '';
    openingHours: string = '';
    showOpenings: boolean = false;

    async created() {
        const settings = await Settings.getInstance();
        this.storeClosed = settings.get(SettingNamespace.OPENINGS, 'close_store')?.value;
        this.storeName = settings.get(SettingNamespace.GENERAL, 'store_name')?.value;
        this.openingHours = settings.get(SettingNamespace.OPENINGS, 'store_openings')?.value.split("|");
    }

    get formattedTime() {
        return (time: string) => convertTo12HourFormat(time);
    }

    get Icon() {
        return Icon;
    }
}
</script>
<style lang="scss">
@import '~foundation-sites/scss/foundation';
@import '~scss/front/settings';

.closed-title {
    margin-bottom: 15px;
}

.closed-content {
    z-index: 90;
    position: relative;
    max-width: 450px;
    h1, p, ul, a {
        color: var(--closed-page-desktop-color);
    }

    ul {
        margin-top: 5px;
        padding-bottom: 15px;
        margin-bottom: 0;
        margin-left: 0;
        list-style-type: none;
    }

    .opening-hours {
       text-transform: uppercase;
       width: 221px;

       @include breakpoint (medium down) {
            display: block;
            margin: auto;
       }
    }

    @include breakpoint(medium down) {
        h1, p, ul,a {
            color: var(--closed-page-mobile-color);
        }
    }
}
</style>
